module.exports = __webpack_public_path__ + "static/testimonial-tpop-julien-3881ac9b1006da2a6ccf9e4430f90e38.jpeg";